import {
  useCallback,
  useEffect,
  useState,
} from "react";

import { toast } from "react-toastify";

import {
  calculateJudoCategories,
} from "../utils/categoryUtils";

const INITIAL_FORM = {
  gender: "M",
  birthDate: "",
  weight: "",
};

export default function useJudoCategoryCalculator({
  season,
}) {
  const [formData, setFormData] =
    useState(INITIAL_FORM);

  const [result, setResult] =
    useState(null);

  const [hasCalculated, setHasCalculated] =
    useState(false);

  const updateField = useCallback(
    (name, value) => {
      setFormData((current) => ({
        ...current,
        [name]: value,
      }));
    },
    []
  );

  const calculate = useCallback(
    ({ showSuccess = true } = {}) => {
      try {
        const nextResult =
          calculateJudoCategories({
            ...formData,
            season,
          });

        setResult(nextResult);
        setHasCalculated(true);

        if (showSuccess) {
          toast.success(
            "Votre catégorie a été calculée."
          );
        }

        return nextResult;
      } catch (error) {
        setResult(null);

        if (showSuccess) {
          toast.error(error.message);
        }

        return null;
      }
    },
    [formData, season]
  );

  /*
   * Si l’utilisateur change uniquement de saison après
   * avoir calculé, le résultat est actualisé automatiquement.
   */
  useEffect(() => {
    if (hasCalculated) {
      calculate({
        showSuccess: false,
      });
    }
  }, [season]);

  const reset = useCallback(() => {
    setFormData(INITIAL_FORM);
    setResult(null);
    setHasCalculated(false);
  }, []);

  return {
    formData,
    result,
    hasCalculated,

    updateField,
    calculate,
    reset,
  };
}